import { render } from "./AcademicBar.vue?vue&type=template&id=913154e4&scoped=true"
import script from "./AcademicBar.vue?vue&type=script&lang=js"
export * from "./AcademicBar.vue?vue&type=script&lang=js"

import "./AcademicBar.vue?vue&type=style&index=0&id=913154e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-913154e4"]])

export default __exports__